module.exports = __webpack_public_path__ + "static/img/run-fail.782d93ae.png";